import { useState } from 'react';
import { noSelectionKey } from '../../../../../utilities/filterAndSortingsUtil';
import { useDispatch } from 'react-redux';
import { setIsUpdateInvitationGroupMappingsPanelOpen } from '../../../../../features/pageFeatures/invitationGroupAdministrationPageSlice';

export const useInteractions = () => {
  const dispatch = useDispatch();

  const [selectedInvitationGroupKey, setSelectedInvitationGroupKey] = useState(
    noSelectionKey,
  );
  const [selectedHearingTypeKey, setSelectedHearingTypeKey] = useState(
    noSelectionKey,
  );

  function handleHearingTypeChange(_, option) {
    setSelectedHearingTypeKey(option.key);
    setSelectedInvitationGroupKey(noSelectionKey);
  }

  function handleInvitationGroupSelect(id) {
    setSelectedInvitationGroupKey(id);
  }

  function handleUpdateInvitationGroupMappings() {
    dispatch(setIsUpdateInvitationGroupMappingsPanelOpen(true));
  }

  return {
    selectedInvitationGroupKey,
    selectedHearingTypeKey,
    handleHearingTypeChange,
    handleInvitationGroupSelect,
    handleUpdateInvitationGroupMappings,
  };
};
